import { Component, Input, OnInit } from '@angular/core';
import { RenaultShortcutMinimizedDTO } from '../../../models/renautl-shortcut-dto';

@Component({
  selector: 'app-shortcut',
  templateUrl: './shortcut.component.html',
  styleUrls: ['./shortcut.component.scss']
})
export class ShortcutComponent implements OnInit {

  @Input() model: RenaultShortcutMinimizedDTO;

  constructor() { }

  ngOnInit(): void {}

}
